import React from "react";
import {Button, Icon, Modal} from "antd";
import PropTypes from "prop-types";
import {sanitizeFieldName} from "../../util/methods";
import ActivityCreate from "../../containers/Activity/create";
import {fetchSubElementFilter} from "../../appRedux/actions";
import {connect} from "react-redux";
import AccessControl from "../AccessControl";

class DocumentList extends React.Component {

  id = 0;
  state = {
    visible: false,
    activityDataList: [],
    editActivityDataList:[],
    currentIndexOfEditActivity:null,
  };

  componentDidMount() {
    this.props.fetchSubElementFilter('Activity');
    const {data = []} = this.props;
    this.setState({
      activityDataList: data
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        activityDataList: nextProps.data
      })
    }
  }

  remove = index => {
    const {activityDataList} = this.state;
    activityDataList.splice(index, 1);
    this.setState({
      activityDataList: activityDataList
    }, ()=> {
      this.props.getActivityData(activityDataList);
    });
  };

  editDocument=index=>{
    this.state.editActivityDataList=this.state.activityDataList[index];
    this.setState({
      visible: true,
      currentIndexOfEditActivity: index,
    });
  }

  showModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      visible: true,
    });
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  handleChange = (e) => {
  };

  handleSubmit = (values, id) => {
    const {activityDataList} = this.state;
    const data = values;
    //
    // if (this.state.currentIndexOfEditActivity){
    //   //documentDataList.push(data);
    //   const newArrayOfDoc=[];
    //   activityDataList && activityDataList.map((item, index)=>{
    //     if (index=== parseInt(this.state.currentIndexOfEditActivity)){
    //       newArrayOfDoc.push(data);
    //     } else {
    //       newArrayOfDoc.push(item);
    //     }
    //   })
    //   activityDataList.splice(0,activityDataList.length);
    //   activityDataList.push(...newArrayOfDoc);
    //   this.setState({
    //     currentIndexOfEditActivity:null,
    //   });
    // } else {
    //   activityDataList.push(data);
    //   this.setState({
    //     currentIndexOfEditActivity:null,
    //   });
    // }
    activityDataList.push(data);
    this.setState({
      activityDataList: activityDataList,
      visible: false
    }, ()=> {
      this.props.getActivityData(activityDataList);
    });
  };

  edit = (id) => {
    this.props.history.push(`/activity/edit/${id}`);
  };

  render() {
    const {item, isDisabled,resourceName,jcData, subElementFilters, data} = this.props;
    const { visible, activityDataList } = this.state;
    delete subElementFilters.activitySerialNo;

    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
      display: 'flex',
      justifyContent: 'space-between'
    };


    const formItems = activityDataList && activityDataList.map((item, index) => {
      return <div key={index} style={style}>
        <div>
          <div>Description: {item && item.description}</div>
          <div>Time Estimate in hour: { item && item.timeEstimateInHour}</div>
        </div>
        <div>
          {item._id ? <Button
            type='primary'
            disabled={!(jcData && jcData.status && jcData.status==='Open')}
            onClick={() => {this.edit(item._id)}}>Edit</Button> : ''}

          {/*{item._id ?'':<Button*/}
          {/*  type='primary'*/}
          {/*  onClick={() => this.editDocument(`${index}`)}*/}
          {/*>Edit</Button>*/}
          {/*}*/}
          <AccessControl resource={this.props.resourceName} permissionNeeded={'d'}
                         roles={this.props.authUser ? this.props.authUser.roles : []} render={(props) => {
            return<>
              {
                item && item._id ? <Button
                  type='danger'
                  // disabled={item && item.allocate && item.allocate.length>0}
                  disabled={(jcData && jcData.status !== 'Open') || !(item && item.deleteAllowed)}
                  onClick={() => this.remove(`${index}`)}
                >Delete</Button> : <Button
                  type='danger'
                  // disabled={item && item.allocate && item.allocate.length>0}
                  // disabled={!(item && item.deleteAllowed)}
                  onClick={() => this.remove(`${index}`)}
                >Remove</Button>
              }
            </>
          }}/>
        </div>
      </div>
    });

    return (
      <div>
        <Modal
          title="Create Activity"
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          footer={null}
        >
          <ActivityCreate data={data}
                          subMaster={true}
                          filters={subElementFilters}
                          modules={''}
                          title={'CREATE'}
                          visible={visible}
                          resource={item && item.options.ref}
                          loading={false}
                          onChange={this.handleChange}
                          onSubmit={this.handleSubmit}
          />
        </Modal>
        {formItems}
        <Button
                // disabled={isDisabled}
                disabled={this.props.title === 'EDIT' && !(jcData && jcData.status && jcData.status === 'Open')}
                type="dashed"
                onClick={this.showModal}
                style={{width: '60%', marginTop: '15px'}}>
          <Icon type="plus"/> Add {sanitizeFieldName((item && item.field) || '')}
        </Button>

      </div>

    )
  }
}

const mapStateToProps = ({commonData}) => {
  return {
    subElementFilters: commonData.subElementFilters
  }
};

function mapDispatchToProps(dispatch) {
  return {
    fetchSubElementFilter,
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(DocumentList);
DocumentList.defaultProps = {};

DocumentList.propTypes = {
  item: PropTypes.object
};
